



//********** Recharge les sliders **************************//

function init() {
    if($().owlCarousel === undefined) return;


    var callForTender = $(".call-for-tender-carousel");
    callForTender.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        center: true,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1,
            },
            1200: {
                items: 3,
            },
        },
    });

    var asks = $(".asks-carousel");
    var offset = 0;
    asks.owlCarousel({
        autoplay: true,
        loop: true,
        margin: 10,
        nav: false,
        dot: true,
        center: true,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1,
            },
            998: {
                items: 2,
            },
            1200: {
                items: 3,
            },
        },
    });


    asks.find('div.active:eq(1)').addClass('slidedefault');

    asks.on('changed.owl.carousel', function (event) {
        if (event.page.size === 1) {
            offset = 0;
        }
    });
    asks.on('translated.owl.carousel', function (event) {

        var offset = 1;
        if (event.page.size === 1) {
            offset = 0;
        }
        asks.find('.owl-item.active').each(function (index) {
            if (index === offset) {
                $(this).addClass('slidedefault');
            } else {
                $(this).removeClass('slidedefault');
            }
        });
    });



    var selection = $(".selection-carousel");
    selection.owlCarousel({
        autoplay: true,
        loop: true,
        nav: false,
        dot: true,
        center: true,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1,
            },
            1024: {
                items: 2,
                center: false,
            },
            1200: {
                items: 3,
            },
        },
    });

    var module = $(".module-carousel");
    module.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1,
            },
        },

    });


    var moduleResidency = $(".module-residency-carousel");
    var item_count = parseInt(moduleResidency.find('> *').length);
    var loop = false;
    if (item_count >= 3) loop = true;
    moduleResidency.owlCarousel({
        autoplay: true,
        nav: true,
        loop: loop,
        dot: false,
        margin: 8,
        autoplayTimeout: 7000,
        onInitialized: function(event) {
            var items = event.item.count;
            if (items <= 1) {
                this.options.responsive= {
                    0: {
                        loop: false,
                        items: 1,
                        center: true,
                    },
                };
            }
            else {
                if (items <= 2) {
                    this.options.responsive= {
                        0: {
                            loop: true,
                            items: 1,
                            center: true,
                        },
                        560: {
                            loop: false,
                            items: 2,
                        },
                    };
                }
                else {
                    this.options.responsive= {
                        0: {
                            items: 1
                        },
                        560: {
                            items: 2,
                        },
                        800: {
                            items: 3
                        },
                    };
                }
            }
        }
    });


    var residency = $(".residency-carousel");
    residency.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1,
            },
        },
    });


    var downloadsA = $(".downloads-a-carousel");
    var loop = downloadsA.data('loop');
    console.log('Loop = ' + loop);
    var item_count = parseInt(downloadsA.find('> *').length);
    var nb_800 = 3;
    var nb_1200 = 4;
    if  (nb_800 > item_count) nb_800 = item_count;
    if  (nb_1200 > item_count) nb_1200 = item_count;
    downloadsA.owlCarousel({
        autoplay: true,
        loop: loop,
        nav: false,
        dot: true,
        center: (item_count%2)!=0,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1,
            },
            800: {
                items: nb_800,
            },
            1200: {
                items: nb_1200,
            },
        },

    });



    var actions = $(".actions-carousel");
    actions.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        margin: 30,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1
            },
            560: {
                items: 2
            },
            980: {
                items: 3,
            },
            1200: {
                items: 4,
            },
        },
    });

    var achievements = $(".achievements-carousel");
    achievements.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        margin: 30,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1
            },
            560: {
                items: 2
            },
            980: {
                items: 3,
            },
        },
    });

    var projects = $(".projects-carousel");
    projects.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        margin: 30,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 3
            }
        },
    });


    var jobOffers = $(".job-offers-carousel");
    var item_count = parseInt(jobOffers.find('> *').length);
    var nb_560 = 2;
    var nb_980 = 3;
    if  (nb_560 > item_count) nb_560 = item_count;
    if  (nb_980 > item_count) nb_980 = item_count;
    jobOffers.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        center: (item_count%2)!=0,
        autoplayTimeout: 7000,
        margin: 30,
        responsive: {
            0: {
                items: 1,
            },
            560: {
                items: nb_560,
            },
            980: {
                items: nb_980,
            },
        },

    });


    var downloadC = $(".downloads-c-carousel");
    downloadC.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        margin: 30,
        autoplayTimeout: 7000,
        responsive: {
            0: {
                items: 1
            },
            560: {
                items: 2
            },
            980: {
                items: 3,
            },
            1200: {
                items: 4,
            },

        },
    });

    var asksB = $(".asks-b-carousel");
    asksB.owlCarousel({
        autoplay: true,
        loop: true,
        nav: true,
        dot: false,
        autoplayTimeout: 7000,
        items: 1
    });
}

function sliders() {

    $(document).ready(function () {
        $(document).ajaxComplete(function () {
            init();
        });
        init();
    });
}

export default sliders;
